// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal } from 'react-bootstrap';
import PdfViewer from '../pdfViewer';

export default class PdfViewerModal extends Component {

  static defaultProps = {
    title: '',

    httpHeaders: {}
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,

    onHide: PropTypes.func.isRequired,

    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,

    httpHeaders: PropTypes.object,

    // the modal title
    title: PropTypes.string
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show;
  }

  // -- events - modal

  onHide = () => {
    this.props.onHide();
  };

  onClose = () => {
    this.props.onHide();
  };

  // -- renderers

  renderBody() {
    return (
      <div className="row pdf_viewer_modal">
        <PdfViewer
          file={this.props.file}
          httpHeaders={this.props.httpHeaders}
        />
      </div>
    );
  }

  render() {
    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={this.onHide}
      >
        <Modal.Header>

          <button
            type="button"
            className="close close-white"
            onClick={this.onClose}
          >
            <span aria-hidden="true">×</span>
          </button>

          <Modal.Title>
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/components/pdfViewer/PdfViewerModal.js